import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./AdmLessonPlanCompletionReport.css";
import { ApiUrl } from "../../../ApiUrl";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ReactPaginate from "react-paginate";

const AdmLessonPlanCompletionReport = () => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;
  const navigate = useNavigate();

  const resolveDocumentUrl = (rawUrl) => {
    if (!rawUrl) return "";
    if (/^https?:\/\//i.test(rawUrl)) return rawUrl;

    const baseOrigin = ApiUrl.apiurl.replace(/\/api\/?$/, "");
    const normalizedPath = rawUrl.startsWith("/") ? rawUrl : `/${rawUrl}`;
    return `${baseOrigin}${normalizedPath}`;
  };

  const fetchReportData = async () => {
    setLoading(true);
    try {
      const academicSessionId = localStorage.getItem("academicSessionId");
      const orgId = localStorage.getItem("orgId");
      const branchId = localStorage.getItem("branchId");

      if (!academicSessionId || !orgId || !branchId) {
        alert("Missing session/org/branch ID. Please login again.");
        setLoading(false);
        return;
      }

      const apiUrl = `${ApiUrl.apiurl}LESSION_PLAN/GetLessonPlanCompletionReport/?academic_year_id=${academicSessionId}&org_id=${orgId}&branch_id=${branchId}`;
      const response = await fetch(apiUrl);
      const data = await response.json();

      if (response.ok && data.message === "success") {
        setReportData(data.data);
        setCurrentPage(0);
      } else {
        setReportData([]);
        setCurrentPage(0);
      }
    } catch (error) {
      console.error("Error fetching lesson plan report:", error);
      setReportData([]);
      setCurrentPage(0);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    fetchReportData();
  };

  const handleClose = () => {
    setReportData([]);
    setCurrentPage(0);
  };

  const handleCloseAndRedirect = () => {
    navigate("/admin/dashboard");
  };

  const handleExportPDF = () => {
    const doc = new jsPDF();
    doc.text("Lesson Plan Completion Report", 14, 15);

    const tableColumn = [
      "Sr. No.",
      "Teacher Name",
      "Lecture No",
      "Module No",
      "Topic Details",
      "Proposed Date",
      "Taught Date",
      "% Course Coverage",
      "Remarks",
    ];

    const tableRows = [];

    reportData.forEach((item, index) => {
      const rowData = [
        index + 1,
        item.teacher_name,
        item.lectureno,
        item.moduleno,
        item.topic_details,
        item.proposedDate,
        item.TaughtDate,
        item.PercentageCompleted,
        item.remarks,
      ];
      tableRows.push(rowData);
    });

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 20,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [0, 123, 255] },
    });

    doc.save("lesson_plan_completion_report.pdf");
  };

  const pageCount = Math.ceil(reportData.length / itemsPerPage);
  const offset = currentPage * itemsPerPage;
  const currentData = reportData.slice(offset, offset + itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="lpc-report-header">
              <h2>LESSON PLAN COMPLETION REPORT</h2>
            </div>

            <div className="lpc-report-controls">
              <button
                type="button"
                className="btn btn-primary me-2"
                style={{
                  width: "150px",
                }}
                onClick={handleSearch}
              >
                Search
              </button>
              {/* <button
                type="button"
                className="btn btn-danger me-2"
                style={{
                  width: "150px",
                }}
                onClick={() => navigate("/admin/dashboard")}
              >
                Close
              </button>
              <button
                className="lpc-btn lpc-close-btn"
                onClick={handleCloseAndRedirect}
              >
                Close & Go to Dashboard
              </button> */}
              <button
                className="lpc-btn lpc-export-btn"
                onClick={handleExportPDF}
              >
                Export to PDF
              </button>
            </div>

            <div className="col-12">
              <div className="table-responsive">
                {loading ? (
                  <p>Loading...</p>
                ) : (
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Teacher Name</th>
                        <th>Lecture No</th>
                        <th>Module No</th>
                        <th>Topic Details</th>
                        <th>Proposed Date</th>
                        <th>Taught Date</th>
                        <th>% Course Coverage</th>
                        <th>Remarks</th>
                        <th>Uploaded Document</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentData.length > 0 ? (
                        currentData.map((item, index) => (
                          <tr key={index}>
                            <td>{offset + index + 1}</td>
                            <td>{item.teacher_name}</td>
                            <td>{item.lectureno}</td>
                            <td>{item.moduleno}</td>
                            <td>{item.topic_details}</td>
                            <td>{item.proposedDate}</td>
                            <td>
                              {item.TaughtDate && item.TaughtDate !== "-" ? (
                                <span className="lpc-taught-date-badge">
                                  {item.TaughtDate}
                                </span>
                              ) : (
                                item.TaughtDate
                              )}
                            </td>
                            <td>{item.PercentageCompleted}</td>
                            <td>{item.remarks}</td>
                            <td>
                              {item.document_url ? (
                                <a
                                  href={resolveDocumentUrl(item.document_url)}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  View
                                </a>
                              ) : (
                                item.uploaded_document || "-"
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="10" className="lpc-no-data">
                            No records found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>
              {reportData.length > 0 && (
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  pageCount={pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageClick}
                  forcePage={currentPage}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmLessonPlanCompletionReport;
